import { render } from "./CountryTransfersChart.vue?vue&type=template&id=0b1f6e0c&scoped=true"
import script from "./CountryTransfersChart.vue?vue&type=script&lang=js"
export * from "./CountryTransfersChart.vue?vue&type=script&lang=js"

import "./CountryTransfersChart.vue?vue&type=style&index=0&id=0b1f6e0c&scoped=true&lang=css"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b1f6e0c"],['__file',"src/components/CountryTransfersChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b1f6e0c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b1f6e0c', __exports__)) {
    console.log('reload')
    api.reload('0b1f6e0c', __exports__)
  }
  
  module.hot.accept("./CountryTransfersChart.vue?vue&type=template&id=0b1f6e0c&scoped=true", () => {
    console.log('re-render')
    api.rerender('0b1f6e0c', render)
  })

}


export default __exports__